import { useLocation } from "react-router-dom";
import {Routes, Route, Link} from 'react-router-dom';
import { useState, useEffect } from "react";
import WorksHeader from "./components/WorksHeader";
// import works from './works.json'

export default function SingleWork (props) {
    
    let work = {};
    let workTitle = "";
    let producer = "";
    let recEng = "";
    let mixEng = "";
    let execProd = "";
    let awards = "";
    let media = "";
    let workBG = "";
    let album = "";
    let label = "";

    const [works, setWorkList] = useState([]);

    useEffect(() => {
    // fetch(`http://localhost:3000/works.json`)
    fetch(`https://krzwlmusic.com/works.json`)
        .then((response) => response.json())
        .then((jsonData) => setWorkList(jsonData))
        .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        document.querySelector("body").scrollTo(0,0)
      }, [works])

    const location = useLocation()
    // if (location.state!=null){
        console.log(typeof(location.state.work) + " " + typeof(works[0]))
    //     console.log(works[0])
        work = location.state ? location.state.work : works[0];
        workTitle = work.type == "record" ? `"${work.title}"` : <i>{work.title}</i>
        
        album = work.album ? (
            <p>{work.album}</p>
        ) : null;

        label = work.label ? (
            <span>{work.label}</span>
        ) : null;
        
        producer = work.producer ? (
            <p>Producer(s): <span>{work.producer}</span></p>
        ) : null;
    
        recEng = work.recEng ? (
            <p>Recording Engineer: <span>{work.recEng}</span></p>
        ) : null;
    
        mixEng = work.mixEng ? (
            <p>Mix Engineer: <span>{work.mixEng}</span></p>
        ) : null;
    
        execProd = work.execProd ? (
            <p>Executive Producer: <span>{work.execProd}</span></p>
        ) : null;
    
        awards = work.awards ? (
            <span>{work.awards}</span>
        ) : null;

        media = work.vidEmbed ? (
            <div className="row pt-2 pb-2" dangerouslySetInnerHTML={{__html: work.vidEmbed}}></div>
        ) : (
            <div className="row pt-2 pb-2" id="workImg"><img src={work.artSm} /></div>
        );
        
        // console.log(work)

        workBG = {backgroundImage: `url(${work.artSm})`}
    // }

    for (let i = 0; i<works.length; i++){
        if (works[i].title == work.title){
            if (i==0){
                var nextWork = works[i+1];
                var prevWork = works[works.length-1];
            } else if (i==works.length-1){
                var nextWork = works[0];
                var prevWork = works[i-1];
            } else {
                var nextWork = works[i+1];
                var prevWork = works[i-1];
            }
        }
    }


    return (
        <>
            {/* <div className="row" id="headerBar">
                <Link to={"/"}><span>JAY "KURZWIEL" OYEBADEJO</span></Link>
            </div> */}
            <WorksHeader />
            <div className="row pb-0 ms-0 me-0" id="workBody">
                <div className="col-1 workNav">
                    <Link 
                        to={"/single-work"}
                        state= {{
                            work: prevWork
                        }}
                    >
                        <p>&#8592;</p>
                    </Link>
                </div>
                <div className="col-10 pb-3" id="workCenter">
                    <div className="row">
                        <div className="col-12"  id="workLeft"  style={workBG}>
                            <div id="workLeftTop">
                                <div className="row pt-3" id="workTitle"><h3>{workTitle}</h3></div>
                                <div className="row pt-0"><h4>{work.artist}</h4></div>
                                {/* <div className="row pt-2" id="workImg"><img src={work.artSm} /></div> */}
                                {media}
                            </div>
                        </div>
                        <div className="col-12" id="workRight">
                            <div className="row" id="workAlbum">{album}</div>
                            <div className="row">{label}</div>
                            <div className="row"><span>{work.date}</span></div>
                            <div className="row">{producer}</div>
                            <div className="row">{recEng}</div>
                            <div className="row">{mixEng}</div>
                            <div className="row">{execProd}</div>
                            <div className="row">{awards}</div>
                        </div>
                    </div>
                    {/* <div className="row pt-3" id="workVid">
                        <div className="row pb-2" dangerouslySetInnerHTML={{__html: work.vidEmbed}}></div>
                    </div> */}
                </div>
                <div className="col-1 workNav">
                    <Link 
                        to={"/single-work"}
                        state= {{
                            work: nextWork
                        }}
                    >
                        &#8594;
                    </Link>
                </div>
            </div>
        </>
    )
}